import React, { createContext, useState, useCallback } from "react";

export const AddressSearchContext = createContext({
    isUserInteracting: false,
    onSetIsUserInteracting: () => {},
    selectedAddress: null,
    onSelectAddress: () => {}
});

const AddressSearchContextProvider = ({ children }) => {
    const [selectedAddress, setSelectedAddress] = useState(null);
    const [isUserInteracting, setIsUserInteracting] = useState(false);

    const handleSelectAddress = useCallback((addressInfo) => {
        setSelectedAddress(addressInfo);
    }, []);

    const handleSetIsUserInteracting = useCallback((isUserInteracting) => {
        setIsUserInteracting(isUserInteracting);
    }, []);

    return (
        <AddressSearchContext.Provider
            value={{
                isUserInteracting,
                onSetIsUserInteracting: handleSetIsUserInteracting,
                selectedAddress,
                onSelectAddress: handleSelectAddress,
            }}
        >
            {children}
        </AddressSearchContext.Provider>
    );
};

export default AddressSearchContextProvider;

